var lists_default = {
  "fontElementMap": "xQtot",
  "orderedlist": "STKvB",
  "bulletedlist": "ps0E8",
  "listItem": "NdNAj"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
